import { CompanyAPI } from '@api';

const getBusesGrades = async () => CompanyAPI.getBusesGrades()
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getBusesGrades };
